import React from 'react';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import PauseCircleOutlineRoundedIcon from '@mui/icons-material/PauseCircleOutlineRounded';
import { isInactive } from '../procedureFormat';
import styles from './ProcedureOverview.module.css';

/** Resumo do cadastro: ativos (com o limite do plano, se houver), no agendamento público e inativos. */
function ProcedureOverview({ procedures, limit }) {
    const active = procedures.filter((p) => !isInactive(p));
    const inactiveCount = procedures.length - active.length;
    const publicCount = active.filter((p) => !!p.public_schedule_enabled).length;

    const tiles = [
        {
            key: 'active',
            icon: <CheckCircleOutlineRoundedIcon fontSize="small" />,
            value: active.length,
            label: limit != null ? `ativos de ${limit} no plano` : (active.length === 1 ? 'ativo' : 'ativos'),
            tone: styles.blue
        },
        {
            key: 'public',
            icon: <PublicOutlinedIcon fontSize="small" />,
            value: publicCount,
            label: 'no agendamento público',
            tone: styles.green
        },
        {
            key: 'inactive',
            icon: <PauseCircleOutlineRoundedIcon fontSize="small" />,
            value: inactiveCount,
            label: inactiveCount === 1 ? 'inativo' : 'inativos',
            tone: styles.gray
        }
    ];

    return (
        <div className={styles.grid}>
            {tiles.map((tile) => (
                <div key={tile.key} className={styles.tile}>
                    <span className={`${styles.icon} ${tile.tone}`}>{tile.icon}</span>
                    <span className={styles.text}>
                        <span className={styles.value}>{tile.value}</span>
                        <span className={styles.label}>{tile.label}</span>
                    </span>
                </div>
            ))}
        </div>
    );
}

export default ProcedureOverview;
